import React from 'react';
import Sidebar from './Sidebar.js';
import AdminHeader from './Header.js';
import { Card, Row, Col, Container } from 'react-bootstrap';
import Breadcrumb from './Breadcrumb';
import { Link } from 'react-router-dom';

const MappingOverview = () => {
    return (
        <>
            <AdminHeader />
            <Container className="pt-2">
                <Row>
                    <Col xs={2} className="p-0">
                    </Col>
                    <Col xs={10} className="p-0">
                        <Breadcrumb />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col xs={3} className="p-0">
                        <Sidebar />
                    </Col>

                    <Col xs={9} className="p-4">
                        <Card>
                            <Card.Body>
                                <h1 className="mb-3">Overview</h1>
                                <Row className="mb-4">
                                    <Col>
                                        <Link to="/mapping-industries" style={{ textDecoration: 'none' }}>
                                            <Card>
                                                <Card.Body>
                                                    <h2 className="text-start">Mapping 1</h2>
                                                    <p>USP-Feature Industry</p>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                    <Col>
                                        <Link to="/mapping-occupation" style={{ textDecoration: 'none' }}>
                                            <Card>
                                                <Card.Body>
                                                    <h2 className="text-start">Mapping 2</h2>
                                                    <p>USP-Feature Occupation</p>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col>
                                        <Link to="/mapping-industries-view" style={{ textDecoration: 'none' }}>
                                            <Card>
                                                <Card.Body>
                                                    <h2 className="text-start">Industries</h2>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                    <Col>
                                        <Link to="/mapping-study-fields-view" style={{ textDecoration: 'none' }}>
                                            <Card>
                                                <Card.Body>
                                                    <h2 className="text-start">Study Fields</h2>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Link to="/mapping-study-degrees-view" style={{ textDecoration: 'none' }}>
                                            <Card>
                                                <Card.Body>
                                                    <h2 className="text-start">Study Degrees</h2>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                    <Col>
                                        <Link to="/mapping-occupation-view" style={{ textDecoration: 'none' }}>
                                            <Card>
                                                <Card.Body>
                                                    <h2 className="text-start">Ocupation</h2>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MappingOverview;
